import { ProposalDAOInterface, ProposalTextsDAOInterface } from '../ProposalDAO';
import { ProposalDAO } from '../ProposalDAOImpl';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';
import { deepClone } from '../../../../utils/objects';
import { generateBSONId } from '../../../../utils/random';

export default class GlossaryDAO extends ProposalDAO implements ProposalTextsDAOInterface {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new GlossaryDAO(proposal, proposalElement);
  }

  glossaryConfigDAOOptions: ProposalNS.GlossaryConfigDAOOptions | null = null;

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return [];
  }

  protected build(): void {
    // test for options
    const daoConfig: ProposalNS.GlossaryConfig = this.proposalElement.DAO as ProposalNS.GlossaryConfig;
    if (daoConfig.glossaryConfigDAOOptions !== undefined) {
      this.glossaryConfigDAOOptions = deepClone(daoConfig.glossaryConfigDAOOptions);

      for (const section of this.glossaryConfigDAOOptions.sections) {
        section.key = this.formatMessage(section.key);
      }

      this.glossaryConfigDAOOptions.sections.sort((a, b) => a.key.localeCompare(b.key));
    }
  }

  extract(content: ProposalNS.GlossaryContent): string {
    let s: string = '';
    const { tag, link, key, children } = content;

    const linkStr = link === undefined ? '' : ` href="${link}" `;

    s += `<${tag}${linkStr}>`;
    if (key !== undefined) {
      s += this.formatMessage(key);
    }

    if (link && key == null) {
      s += link;
    }

    if (children !== undefined) {
      for (const child of children) {
        s += this.extract(child);
      }
    }
    s += `</${tag}>`;

    return s;
  }

  getTexts(metadata?: ProposalNS.DAOGetTextsMetadata): Array<{ text: string; className?: string; _id?: string }> {
    const pageOverflowIndex: number = metadata !== undefined && metadata.pageOverflowIndex !== undefined ? metadata.pageOverflowIndex : 0;

    const out: Array<{ text: string; className?: string; _id?: string }> = [];

    if (this.glossaryConfigDAOOptions !== null) {
      const limit: number = this.glossaryConfigDAOOptions.definitionPerPage[this.locale] || 1;
      let count: number = 0;
      for (const section of this.glossaryConfigDAOOptions.sections) {
        if (count >= limit * pageOverflowIndex) {
          const { tag, key, content, showKey } = section;
          out.push({
            text: `
              ${showKey === false ? '' : `<${tag}>${key}</${tag}>`}
              ${content.map(c => this.extract(c)).join('')}
            `,
            _id: generateBSONId(),
          });
        }
        if (++count >= limit * (1 + pageOverflowIndex)) {
          break;
        }
      }
    }
    return out;
  }
}
